module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "id": "unnumbered-2"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "unnumbered-2-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("HART and DRAKE Medical Suspense")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "unnumbered-2-text"
    }
  }, [_c('div', {
    staticClass: "blockquote-container prose without-attribution"
  }, [_c('blockquote', {
    staticClass: "prose without-attribution"
  }, [_c('div', {
    staticClass: "blockquote-image-block blockquote-image-aspect-wide"
  }, [_c('div', {
    staticClass: "blockquote-image-size-container"
  }, [_c('img', {
    staticClass: "blockquote-image-image",
    attrs: {
      "alt": "",
      "src": "images/blockquote-big-66-screen.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first blockquote-position-last"
  }, [_vm._v("A pulse pounding adrenaline rush.” "), _c('i', [_vm._v("~Lisa Gardner")])])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-chapter first-full-width first-after-blockquote"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/hart-and-drake/",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("NERVES OF STEEL,")]), _vm._v(" Hart & Drake Book #1")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/hart-and-drake/",
      "target": "_blank"
    }
  }, [_vm._v("SLEIGHT OF HAND, Hart & Drake Book #2")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/hart-and-drake/",
      "target": "_blank"
    }
  }, [_vm._v("FACE TO FACE, Hart and Drake Book #3")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "https://cjlyons.net/books/hart-and-drake/",
      "target": "_blank"
    }
  }, [_vm._v("EYE OF THE STORM, Hart and Drake Book #4")])]), _vm._v(" "), _c('hr', {
    staticClass: "implicit-break"
  }), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_vm._v("Want")]), _vm._v(" to be the first to have a chance to read the new books? Sign up for my "), _c('a', {
    staticClass: "content-external-link",
    attrs: {
      "href": "http://cjlyons.net/signup",
      "target": "_blank"
    }
  }, [_vm._v("Thrillers with Heart newsletter HERE")]), _vm._v("—and you’ll also get a free copy of the first Lucy adventure, SNAKE SKIN!")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-photograph inline-image-size-full inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://cjlyons.net/signup",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "email signup",
      "src": "images/newmailsignupvellum.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_c('i', [_vm._v("(Already read SNAKE SKIN? Feel free to share this offer with your thriller-loving friends!)")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Be sure to open the Thrillers with Heart emails; they’ll arrive every few weeks with info on contests, new books, and exclusive offers for my readers!")]), _vm._v(" "), _c('div', {
    staticClass: "inline-image inline-image-kind-freestanding inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin"
  }, [_c('div', {
    staticClass: "inline-image-container"
  }, [_c('a', {
    staticClass: "link-contains-image",
    attrs: {
      "href": "http://cjlyons.net/signup",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Thanks for reading! CJ",
      "src": "images/image-300thanks-448.jpg"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cda3d9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hart-and-drake-medical-suspense.vue
// module id = 72
// module chunks = 0